const React = require('react');
const ControlledTextField = require('./ControlledTextField');

const {
    SINGLE_LINE_FIELD_HEIGHT,
    SINGLE_LINE_INPUT_HEIGHT,
    FIELD_LABEL_COLOR,
    fieldLabelColorStyles
} = require('./singleLineFieldStyles');

const internals = {};

internals.textareaFieldStyles = `
    width: 100%;
    margin: 0;

    ${fieldLabelColorStyles}

    &.MuiFormControl-root,
    div.MuiFormControl-root {
        padding: 0 !important;
        min-height: ${SINGLE_LINE_FIELD_HEIGHT}px !important;
        height: auto !important;
    }

    label.MuiInputLabel-root {
        height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
        line-height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
    }

    label.MuiInputLabel-filled:not(.MuiInputLabel-shrink) {
        transform: translate(12px, 16px) scale(1) !important;
    }

    label.MuiInputLabel-shrink {
        transform: translate(12px, 7px) scale(0.75) !important;
    }

    div.MuiInput-root {
        margin-top: 16px !important;
        padding: 0 !important;
    }

    div.MuiFilledInput-root {
        align-items: center !important;
        flex-wrap: nowrap !important;
        margin-top: 0 !important;
        min-height: ${SINGLE_LINE_FIELD_HEIGHT}px !important;
        padding-top: 24px !important;
        padding-bottom: 9px !important;
        padding-right: 0 !important;
    }

    .MuiInput-underline:before {
        height: 2px !important;
    }

    textarea.MuiInputBase-input {
        min-height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
        line-height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        box-sizing: content-box;
        resize: none;
    }

    &.np-placeholder-in-label {
        position: relative !important;
        box-sizing: border-box !important;
        padding: 16px 0 17px !important;
        min-height: ${SINGLE_LINE_FIELD_HEIGHT}px !important;
        height: auto !important;

        label.MuiInputLabel-root,
        label.MuiInputLabel-filled:not(.MuiInputLabel-shrink),
        label.MuiInputLabel-shrink {
            position: relative !important;
            top: auto !important;
            left: auto !important;
            transform: none !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            white-space: normal !important;
            overflow: hidden !important;
            text-overflow: unset !important;
            overflow-wrap: break-word;
            height: auto !important;
            max-height: ${SINGLE_LINE_INPUT_HEIGHT * 2}px !important;
            line-height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
            width: calc(100% - 60px);
            max-width: calc(100% - 60px) !important;
            box-sizing: border-box;
            margin: 0 0 0 12px !important;
            padding: 0 !important;
            z-index: 1;
            pointer-events: none;
        }

        div.MuiFilledInput-root,
        div.MuiInput-root {
            position: absolute !important;
            inset: 0;
            align-items: stretch !important;
            margin-top: 0 !important;
            min-height: 0 !important;
            height: 100% !important;
            padding: 0 !important;
            z-index: auto !important;
        }

        textarea.MuiInputBase-input {
            position: relative !important;
            z-index: 2;
            box-sizing: border-box !important;
            min-height: 0 !important;
            height: 100% !important;
            margin: 0 !important;
            padding: 16px 48px 17px 12px !important;
            line-height: ${SINGLE_LINE_INPUT_HEIGHT}px !important;
            background: transparent !important;
            color: transparent !important;
            caret-color: ${FIELD_LABEL_COLOR};
        }
    }
`;

internals.mergeFieldStyles = (...styles) => styles
    .filter(Boolean)
    .join('\n');

internals.getTextareaRows = ({
    maxRows,
    value
}) => {

    const lineCount = String(value ?? '').split('\n').length;
    const resolvedMaxRows = Number(maxRows);
    const cappedRows = Number.isFinite(resolvedMaxRows) && resolvedMaxRows > 0
        ? Math.min(lineCount, resolvedMaxRows)
        : lineCount;

    return Math.max(1, cappedRows);
};

module.exports = function ControlledTextareaField(props) {

    const {
        textFieldProps = {},
        ...rest
    } = props;
    const rows = internals.getTextareaRows({
        maxRows: textFieldProps.maxRows,
        value: rest.value
    });

    return <ControlledTextField
        {...rest}
        textFieldProps={{
            multiline: true,
            singleLine: false,
            ...textFieldProps,
            minRows: undefined,
            maxRows: undefined,
            rows,
            InputProps: {
                ...(textFieldProps.InputProps || {}),
                inputComponent: 'textarea'
            },
            inputProps: {
                ...(textFieldProps.inputProps || {}),
                rows,
                title: textFieldProps.inputProps?.title || textFieldProps.inputProps?.['aria-label'] || rest.label
            },
            fieldStyles: internals.mergeFieldStyles(
                internals.textareaFieldStyles,
                textFieldProps.fieldStyles
            )
        }}
    />;
};

module.exports.internals = internals;
